import PropTypes from 'prop-types'

export function FormDebugger ({ state }) {
  return (
    <div>
      <pre style={{ fontFamily: 'monospace' }}>
        {JSON.stringify(state, null, 2)}
      </pre>
    </div>
  )
}
FormDebugger.propTypes = {
  state: PropTypes.bool.isRequired
}
